import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';

/**
 * Estado de conexão confiável, via @capacitor/network (que no WebView móvel é
 * mais fiel que o navigator.onLine usado pelo ABP). Centraliza o sinal de
 * online/offline para o resto do app consumir (banner, e o refresh resiliente
 * de sessão decidir se vale tentar quando há rede).
 *
 * Começa otimista (online) para não bloquear o app antes do primeiro status.
 */
@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private readonly connectedSubject = new BehaviorSubject<boolean>(true);

  readonly connected$: Observable<boolean> = this.connectedSubject.pipe(distinctUntilChanged());

  get isConnected(): boolean {
    return this.connectedSubject.value;
  }

  async init(): Promise<void> {
    try {
      const status = await Network.getStatus();
      this.connectedSubject.next(status.connected);
      Network.addListener('networkStatusChange', status => {
        this.connectedSubject.next(status.connected);
      });
    } catch {
      // Se o plugin falhar por algum motivo, assume online para não travar nada.
      this.connectedSubject.next(true);
    }
  }
}
